<p-toast position="top-right"></p-toast>
<div class="card">
    <div class="card-header">
        <h4 class="card-title">{{titile}} </h4>
    </div>
    <div class="card-body">
        <!-- First Row -->
        <div class="row">

            <!-- Meta Data -->
            <div class="col-md-6 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Details</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label for="name">Name <span class="required">*</span><span class="x-small-text">(Only letters, numbers, underscores
                                (_) and hyphens (-) are allowed. No spaces or special characters)</span></label>
                            <input type="text" class="form-control" id="name" [disabled]="viewModeOn" [(ngModel)]="name"
                                placeholder="Enter Name" (ngModelChange)="checkNameValidity()"
                                (keypress)="allowValidNameChars($event)" />

                            <div *ngIf="isNameInvalid" class="text-danger">
                                <small>Please enter alpha numeric.</small>
                            </div>
                            <div *ngIf="isNameInvalid" class="text-danger">
                                <small>Only letters, numbers, underscores (_) and hyphens (-) are allowed. No spaces or
                                    special characters.</small>
                            </div>


                        </div>
                        <div class="form-group mb-3">
                            <label for="description">Description</label>
                            <input type="text" class="form-control" id="description" [disabled]="viewModeOn"
                                [(ngModel)]="description" placeholder="Enter Description" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Storage -->
            <div class="col-md-6 mb-3">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Storage</h4>
                    </div>
                    <div class="card-body">
                        <div class="form-group mb-3">
                            <label>Vector Store <span class="required">*</span></label>
                            <p-dropdown [options]="knowledgeBaseDropDownList?.vectorStores" [disabled]="viewModeOn"
                                [(ngModel)]="selectedVectorStore" optionLabel="name" optionValue="name"
                                placeholder="Select VectorStore"
                                (ngModelChange)="onVectorStoreChange($event)"></p-dropdown>
                        </div>
                        <div *ngIf="selectedVectorStore === 'External'">
                            <div class="form-group mb-3">
                                <label>VectorStore URL <span class="required">*</span></label>
                                <input type="text" class="form-control" [(ngModel)]="vectorStoreUrl"
                                    placeholder="Enter URL" (ngModelChange)="checkUrlValidity()" />
                                <div *ngIf="isUrlInvalid" class="text-danger">
                                    <small>Please enter a valid URL (e.g., http://example.com).</small>
                                </div>
                            </div>
                            <div class="form-group mb-3">
                                <label>VectorStore Username <span class="required">*</span></label>
                                <input type="text" class="form-control" [(ngModel)]="vectorStoreUsername"
                                    placeholder="Enter Username" />
                            </div>
                            <div class="row mb-3">
                                <label>VectorStore Password <span class="required">*</span></label><br>
                                <p-password [(ngModel)]="vectorStorePassword" [toggleMask]="true" [feedback]="false"
                                    placeholder="Enter Password">
                                </p-password>

                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>



        <div>
            @if(!viewModeOn){
            <div class="mt-4">
                <div class="group-button">
                    <button type="submit" class="btn btn-primary waves-effect waves-light me-2" (click)="onSubmit()">
                        {{buttonText}}
                    </button>
                    @if(!knowledgebaseId){
                    <button type="button" class="btn btn-soft-light waves-effect waves-light me-2" (click)="onReset()">
                        Reset
                    </button>
                    }
                    <button type="button" class="btn btn-soft-light waves-effect waves-light" (click)="close()">
                        Cancel
                    </button>
                </div>
            </div>
            }
        </div>
    </div>
</div>